<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.globechek.com" rel="noopener">Company</a>
          </li>
          <li>
            <a href="https://www.facebook.com/GlobeChek/" rel="noopener">Social</a>
          </li>
          <li>
            <a href="https://www.globechek.com/terms-of-service/" rel="noopener">Agreement</a>
          </li>
        </ul>
      </nav>

      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.globechek.com" target="_blank" rel="noopener">
          <span style="font-weight:400;">Globe</span>
          <span style="font-weight:500; color: #444;">Chek</span> </a
        ><span> Inc.</span>
        <span style="padding-left: 10px; font-size: 12px;">
          &nbsp; What we see <i class="material-icons">remove_red_eye</i> may save your sight!</span
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
<style></style>
